import React, { ChangeEvent, FC, useEffect, useState } from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import { useGetAllStatesQuery } from "../../../states/statesApi";
import { useGetEnumsQuery } from "../../../../../app/globalApi";
import { OptionType } from "../../../../../helpers/utils/StyleUtils";
import { handleRTKQuery } from "../../../../../helpers/utils/RtkQueryUtils";
import Modal from "../../../../../components/common/form/Modal";
import Form from "../../../../../components/common/form/Form";
import InputField from "../../../../../components/common/form/InputField";
import Button from "../../../../../components/common/form/Button";
import SelectField from "../../../../../components/common/form/SelectField";
import { createOptionListForSelectTag } from "../../../../../helpers/utils/Utils";
import { useCreateStateCodeAliasMutation, useGetStateCodeAliasByIdQuery, useUpdateStateCodeAliasMutation } from "../../stateCodeAliasApi";
import { useGetAllCountyByStateIdQuery } from "../../../counties/countiesApi";
import { useParams } from "react-router";
import { useGetStateCodeByIdQuery } from "../../stateCodeApi";



interface props {
    show: boolean;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
    aliasId?: string,
    isReadOnly?: boolean;
}

const StateCodeAliasFieldForm: FC<props> = ({ show, setShow, aliasId, isReadOnly, }) => {

    const { codeId } = useParams();
    const [updateAliasApi, updateAliasApiResponse] = useUpdateStateCodeAliasMutation();
    const [createStateCodeApi, createStateCodeApiResponse] = useCreateStateCodeAliasMutation();
    const [aliasData, setAliasData] = useState<any>({});
    const statesApiResult = useGetAllStatesQuery("");
    const countiesApiResult = useGetAllCountyByStateIdQuery(aliasData?.state?.value ?? skipToken);
    const { data: aliasDataById } = useGetStateCodeAliasByIdQuery(aliasId ?? skipToken);
    const { data: enums } = useGetEnumsQuery("");
    const stateCodeData = useGetStateCodeByIdQuery(codeId ?? skipToken);

    useEffect(() => {
        if (aliasDataById) {
            setAliasData({
                alias: aliasDataById?.alias || "",
                stateCodeSource: aliasDataById?.stateCodeSource
                    ? { label: aliasDataById.stateCodeSource, value: aliasDataById.stateCodeSource }
                    : null,
                state: aliasDataById?.stateId
                    ? {
                        value: aliasDataById.stateId,
                        label: statesApiResult?.data?.find((el: any) => el?.id === aliasDataById?.stateId)?.stateName || ''
                    }
                    : null,

                countcountyIdies: aliasDataById?.countyId
                    ? [{ label: aliasDataById.countyId?.countyName, value: aliasDataById.countyId?.id }]
                    : []
            });
        }
    }, [aliasDataById, statesApiResult?.data]);


    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | { name: string; value: OptionType | null }) => {
        const { name, value } = "target" in e ? e.target : e;

        if (name == "state" && !value) {
            setAliasData({
                ...aliasData,
                [name]: value,
                countyId: null
            })
        } else {
            setAliasData({
                ...aliasData,
                [name]: value,
            })
        }

    }


    const handleSubmit = async (e: any) => {
        e.preventDefault();

        const payload = {
            alias: aliasData?.alias || "",
            stateCodeSource: aliasData?.stateCodeSource?.value,
            countyId: aliasData?.countyId?.value || null,
            stateCode: stateCodeData?.data,
            stateId: aliasData?.state?.value || null,
        };

        if (!aliasId) {
            await handleRTKQuery(
                async () => {
                    return await createStateCodeApi({
                        ...payload,
                    }).unwrap();
                },
                (isSuccess: boolean) => {
                    if (isSuccess) {
                        setAliasData({});
                        setShow(false);
                    }
                }
            );
        } else {
            await handleRTKQuery(
                async () => {
                    return await updateAliasApi({ id: aliasId, requestBody: payload }).unwrap();
                },
                (isSuccess: boolean) => {
                    if (isSuccess) {
                        setAliasData({});
                        setShow(false);
                    }
                }

            );
        }
    };



    return (
        <>
            <Modal
                title={aliasId ? "Update Alias Form" : "Add Alias Form"}
                show={show}
                setShow={setShow}
                className="w-2/5 justify-center item-center  bg-text-0 rounded-lg shadow-lg"
                fields={
                    <Form onSubmit={handleSubmit} fields={
                        <div className=" ">
                            <InputField
                                label="Alias"
                                name="alias"
                                value={aliasData?.alias || ""}
                                type="text"
                                onChange={handleOnChange}
                                required
                                disabled={isReadOnly}
                            />

                            <SelectField
                                placeholder='State Code Source...'
                                value={aliasData?.stateCodeSource}
                                options={createOptionListForSelectTag(enums?.["StateCodeSource"], "value", "constant")}
                                onChange={(selectedOption) => {
                                    handleOnChange({ name: "stateCodeSource", value: selectedOption })
                                }}
                                label={"State Code Source"}
                                isDisabled={isReadOnly}
                            />

                            <SelectField
                                placeholder='State...'
                                value={aliasData?.state}
                                options={createOptionListForSelectTag(statesApiResult?.data, "stateName", "id")}
                                onChange={(selectedOption) => {
                                    handleOnChange({ name: "state", value: selectedOption })
                                }}
                                label={"Select State"}
                                isDisabled={aliasData?.countyId || isReadOnly}
                            />

                            <SelectField
                                placeholder='County...'
                                value={aliasData?.countyId}
                                options={createOptionListForSelectTag(countiesApiResult?.data, "countyName", "id")}
                                onChange={(selectedOption) => {
                                    handleOnChange({ name: "countyId", value: selectedOption })
                                }}
                                label={"County"}
                                isDisabled={aliasData?.state || isReadOnly}
                            />

                            {/* Footer Buttons */}
                            {!isReadOnly &&
                                <div className="flex justify-center gap-2 pt-4 mt-4">
                                    <Button btnText="Cancel" isLoading={false} type="close" onClick={() => setShow(false)} />
                                    <Button
                                        btnText={aliasId ? "Update" : "Submit"}
                                        isLoading={aliasId ? updateAliasApiResponse.isLoading : createStateCodeApiResponse.isLoading}
                                        type="submit"
                                        isDisabled={false}
                                    />
                                </div>
                            }

                        </div >
                    } />

                }
            />

        </>
    )
}
export default StateCodeAliasFieldForm;